var r=function(r,a){for(var n=-1,t=null==r?0:r.length,e=Array(t);++n<t;)e[n]=a(r[n],n,r);return e};export{r as default};
//# sourceMappingURL=_arrayMap.js.map
